<template>
	<div>
		<main class="main-wrapper flex-grow-1 with-footer">
			<div class="d-flex align-items-center bg-white">
				<div
					class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
					{{ $t("704") }}
				</div>
				<div class="mgr-24 right-button">
					<button class="mdc-button mdc-dialog__button" data-mdc-dialog-action="discard" tabindex="0"
						type="button" @click="goBackToSurvey" @keypress="goBackToSurvey">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-color-primary font-r">{{
							$t("3312")
						}}</span>
					</button>
				</div>
			</div>
			<div class="divider"></div>
			<transition name="slide">
				<component :is="questions[currentQuestionIndex].type.value" v-if="questions[currentQuestionIndex]"
					:key="questions[currentQuestionIndex].id" ref="questionComp" :question="questions[currentQuestionIndex]"
					:setedAnswer="answers[questions[currentQuestionIndex].id]" @setAnswers="setAnswers">
				</component>
			</transition>
		</main>
		<div class="footer bg-white bottomStack">
			<div class="divider"></div>
			<div class="container container--narrow pdb-0">
				<div class="d-flex align-items-center justify-content-between pdt-4 pdb-3">
					<div v-if="!isFirstQuestion" class="d-flex align-items-center w-120">
						<button class="mdc-button t-color-secondaryBtnText" tabindex="0" @click="prevQuestion()"
							@keypress="prevQuestion()">
							<div class="mdc-button__ripple"></div>
							<i aria-hidden="true" class="material-icons mdc-button__icon">chevron_left</i>
							<span class="mdc-button__label t-body2 font-r">{{
								$t("711")
							}}</span>
						</button>
					</div>
					<div v-else class="d-flex align-items-center w-120"></div>
					<question-timer v-if="useTimeout" :key="timerTime" :time="timeout" @timerEnd="timerSubmitSurvey"
						@timerState="setTimerState"></question-timer>
					<div v-if="!isLastQuestion" class="d-flex align-items-center justify-content-end w-120">
						<button class="mdc-button bg-secondary t-color-secondaryBtnText mgr--12" tabindex="0"
							@click="nextQuestion()" @keypress="nextQuestion()">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r t-nowrap">{{
								$t("712")
							}}</span>
							<i aria-hidden="true" class="material-icons mdc-button__icon">chevron_right</i>
						</button>
					</div>
					<div v-if="isLastQuestion" class="d-flex align-items-center justify-content-end w-120">
						<button :disabled="disabled"
							class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4" tabindex="0"
							@click="submitSurvey()" @keypress="submitSurvey()">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r t-nowrap">{{
								$t("745")
							}}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 설문 응시 컴포넌트(survey take component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import Timer from "../exam/question/Timer.vue";
import { surveyMixin } from "@/mixins/survey.js";
import { MDCRipple } from "@material/ripple";

export default {
	name: "surveyIntro",
	components: {
		"question-timer": Timer,
		SHORT_ANSWER: () => import("./question/ShortAnswer.vue"),
		CHOICE_SINGLE: () => import("./question/ChoiceSingle.vue"),
		CHOICE_MULTIPLE: () => import("./question/ChoiceMultiple.vue"),
		STARS: () => import("./question/Stars.vue"),
		RANKING: () => import("./question/Ranking.vue"),
	},

	mixins: [surveyMixin],

	data() {
		return {
			paper: null,
			questions: [],
			answers: {},
			currentQuestionIndex: 0,

			window: null,
			useTimeout: false,
			timeout: 0,
			eachViewFeedback: false,
			questionSequence: "",
			timerPauseState: false,
			timerTime: 0,
			disabled: false,
			isMicro: this.$route.query.isMicro === true,
			routePath: "",
		};
	},

	created() {
		this.fatchData();
	},

	computed: {
		// is first question
		isFirstQuestion() {
			return this.currentQuestionIndex === 0;
		},

		// is last question
		isLastQuestion() {
			return this.currentQuestionIndex === this.questions.length - 1;
		},
	},

	mounted() {
		if (this.isMicro) {
			this.routePath = "/micro/";
		} else {
			this.routePath = "/learn/";
		}
		this.setMaterialUi();
	},

	methods: {
		// 설문지 문항 정보 불러오기(set start / get survey data)
		setMaterialUi() {
			const buttonRipple = [].map.call(
				document.querySelectorAll(".mdc-button"),
				function (el) {
					let button = new MDCRipple.attachTo(el);
					return button;
				}
			);
		},

		fatchData() {
			let params = {
				respondentId: this.$route.params.respondentId,
			};

			// set survey start
			surveyApi
				.surveyRespondentStart(params)
				.then((response) => {
					// get survey paper information
					return surveyApi.surveyRespondentWindow(params);
				})
				.then((response) => {
					this.window = response.data.data;
					this.useTimeout = this.window.useTimeout;
					this.timeout = this.window.timeout;
					this.eachViewFeedback = this.window.eachViewFeedback;
					this.questionSequence = this.window.questionSequence;

					// get survey question & set data
					surveyApi.surveyRespondentGroups(params).then((response) => {
						this.paper = response.data.data;

						let number = 1;
						_.each(this.paper, (group, groupIndex) => {
							_.each(group.questions, (question, questionIndex) => {
								question.essential = group.essential;
								question.number = number++;

								this.questions.push(question);
							});
						});
						this.initAnswers();
					});
				});
		},

		// 타이머 만료시 동작(popup when timer expires)
		timerSubmitSurvey() {
			this.$confirm({
				title: this.$t("720"), //설문 응답 시간 만료
				content: this.$t("721") + "<br>" + this.$t("751"), //제한된 응답 시간이 만료되었습니다. 설문 종료 시 현재까지 응답한 내용만 제출됩니다.
				accept: this.$t("723"), //재응답하기
				cancel: this.$t("722"), //설문 종료
			})
				.then(() => {
					this.timerTime++;
					this.$router.push(
						`/independent/survey/${this.$route.params.distId}/${this.$route.params.respondentId}/intro`
					);
				})
				.catch(() => {
					this.moveSurveyView();
				});
		},

		// 설문 제출(submit survey)
		submitSurvey() {
			this.disabled = false;
			if (
				this.questions[this.currentQuestionIndex].type.value === "SHORT_ANSWER"
			) {
				let getValidated = this.$refs.questionComp.validateTextArea();
				if (getValidated) {
					this.submitSurveyPart();
				}
			} else {
				this.submitSurveyPart();
			}
		},

		// This method belong to submit function
		submitSurveyPart() {
			this.$showLoading();
			let isSolved =
				this.answers[this.questions[this.currentQuestionIndex].id].isSolved;
			let essential = this.questions[this.currentQuestionIndex].essential;
			if (essential) {
				if (isSolved) {
					let distId = this.$route.params.distId;
					let respondentId = this.$route.params.respondentId;
					const learnId = this.$route.query.learnId;
					const surveyType = this.$route.query.type;

					let params = {
						respondentId: respondentId,
						answers: this.answers,
						learnId: learnId,
					};

					const submitSurveyRequest =
						surveyType === "LEARN"
							? surveyApi.surveyLearnRespondentSubmit(params)
							: surveyType === "MICRO"
								? surveyApi.surveyMicroLearnRespondentSubmit(params)
								: surveyApi.surveyRespondentSubmit(params);

					submitSurveyRequest
						.then((response) => {
							this.$hideLoading();
							let closeMessage = response.data.data.closeMessage;
							this.$alert({
								content: this.$t("3058"),
								accept: this.$t("3059"),
							})
								.then(() => {
									if (this.$route.query.distributionType === "SATISFACTION") {
										this.$router.push(
											this.routePath +
											this.$route.query.learnId +
											"?status=" +
											this.$route.query.status +
											"&tab=viewSurvey"
										);
									} else {
										this.$hideLoading();
										this.$router.push({
											name: "IndependentSurveyResult",
											params: {
												distId: distId,
												respondentId: respondentId,
											},
											query: {
												status: this.$route.query.status,
												learnId: this.$route.query.learnId,
												distributionType: this.$route.query.distributionType,
											},
										});
									}
								})
								.catch(() => {
									this.$hideLoading();
									//this.$router.push('/login')
								});
						})
						.catch((err) => {
							this.$hideLoading();
							let responseData = err.response.data.meta;
							let alertMessage = this.$t("3169");
							if (responseData.errCode === 2201) {
								alertMessage = this.$t("3167"); // this.$t('TODO-이미 재출한 시험지 입니다.')
							}

							this.$alert({
								content: alertMessage,
								accept:
									responseData && responseData.errCode === 2201
										? this.$t("3168")
										: this.$t("3170"),
							}).then(() => {
								if (this.$route.query.distributionType === "SATISFACTION") {
									this.$router.push(
										this.routePath +
										this.$route.query.learnId +
										"?status=" +
										this.$route.query.status +
										"&tab=viewSurvey"
									);
								} else {
									this.$router.push({
										name: "IndependentSurveyTotalView",
										params: { distId: this.$route.params.distId },
										query: this.$route.query,
									});
								}
							});
						});
					
				} else {
					this.$hideLoading();
					this.$snackOpen({
						contents: this.$t("756"), //필수 질문에 응답해주세요.
						btnDisplayYN: true,
						btnDisplay: this.$t("757"), // 확인
					}).then(() => { });
				}
			} else {
				this.$hideLoading();
				let distId = this.$route.params.distId;
				let respondentId = this.$route.params.respondentId;
				const learnId = this.$route.query.learnId;
				const surveyType = this.$route.query.type;

				let params = {
					respondentId: respondentId,
					answers: this.answers,
					learnId: learnId,
				};

				const submitSurveyRequest =
					surveyType === "LEARN"
						? surveyApi.surveyLearnRespondentSubmit(params)
						: surveyType === "MICRO"
							? surveyApi.surveyMicroLearnRespondentSubmit(params)
							: surveyApi.surveyRespondentSubmit(params);
				
				submitSurveyRequest
					.then((response) => {
						let closeMessage = response.data.data.closeMessage;
						this.$alert({
							content: this.$t("3058"),
							accept: this.$t("3059"),
						})
							.then(() => {
								if (this.$route.query.distributionType === "SATISFACTION") {
									this.$router.push(
										this.routePath +
										this.$route.query.learnId +
										"?status=" +
										this.$route.query.status +
										"&tab=viewSurvey"
									);
								} else {
									this.$router.push({
										name: "IndependentSurveyResult",
										params: {
											distId: distId,
											respondentId: respondentId,
										},
										query: {
											status: this.$route.query.status,
											learnId: this.$route.query.learnId,
											distributionType: this.$route.query.distributionType,
										},
									});
								}
							})
							.catch(() => {
								this.$hideLoading();
								//this.$router.push('/login')
							});
					})
					.catch((err) => {
						let responseData = err.response.data.meta;
						let alertMessage = this.$t("3078"); //'TODO-시험지 제출 중 오류가 발생하였습니다. 다시 응시해 주시기 바랍니다.'
						if (responseData.errCode === 2201) {
							alertMessage = this.$t("3167"); // this.$t('TODO-이미 재출한 시험지 입니다.')
						}

						this.$alert({
							content: alertMessage,
							accept:
								responseData && responseData.errCode === 2201
									? this.$t("3168")
									: this.$t("3079"),
						}).then(() => {
							this.$hideLoading();
							if (this.$route.query.distributionType === "SATISFACTION") {
								this.$router.push(
									this.routePath +
									this.$route.query.learnId +
									"?status=" +
									this.$route.query.status +
									"&tab=viewSurvey"
								);
							} else {
								this.$router.push({
									name: "IndependentSurveyTotalView",
									params: { distId: this.$route.params.distId },
									query: this.$route.query,
								});
							}
						});
					});
				
			}
		},

		// 다음 문항으로 이동(Go to the next question)
		nextQuestion() {
			if (
				this.questions[this.currentQuestionIndex].type.value === "SHORT_ANSWER"
			) {
				let getValidated = this.$refs.questionComp.validateTextArea();
				if (getValidated) {
					let isSolved =
						this.answers[this.questions[this.currentQuestionIndex].id].isSolved;

					let essential = this.questions[this.currentQuestionIndex].essential;

					if (essential) {
						if (isSolved) {
							this.currentQuestionIndex++;
						} else {
							this.$snackOpen({
								contents: this.$t("756"), //필수 질문에 응답해주세요.
								btnDisplayYN: true,
								btnDisplay: this.$t("757"), // 확인
							}).then(() => { });
						}
					} else {
						this.currentQuestionIndex++;
					}
				}
			} else {
				let isSolved =
					this.answers[this.questions[this.currentQuestionIndex].id].isSolved;

				let essential = this.questions[this.currentQuestionIndex].essential;

				if (essential) {
					if (isSolved) {
						this.currentQuestionIndex++;
					} else {
						this.$snackOpen({
							contents: this.$t("756"), //필수 질문에 응답해주세요.
							btnDisplayYN: true,
							btnDisplay: this.$t("757"), // 확인
						}).then(() => { });
					}
				} else {
					this.currentQuestionIndex++;
				}
			}
		},

		// 이전 문항으로 이동(Go to the prev question)
		prevQuestion() {
			this.currentQuestionIndex--;
		},

		// 타이머 상태 업데이트(Timer status update)
		setTimerState(state) {
			this.timerPauseState = state;
		},

		// 설문 문항 답안 설정(set answer)
		setAnswers(answer) {
			this.answers[answer.questionId] = {
				text: answer.text,
				comment: answer.comment,
				selected: answer.selected,
				weight: answer.weight,
				isSolved: answer.isSolved,
			};
		},

		// 설문 문항 답안 초기화(init answer)
		initAnswers() {
			_.each(this.questions, (question) => {
				let defaultSelected = [];
				let defaultWeight = {};

				if (
					question.type.value === "CHOICE_SINGLE" ||
					question.type.value === "CHOICE_MULTIPLE"
				) {
					defaultSelected = _(question.choices.length).times(() => {
						return false;
					});
				} else if (question.type.value === "RANKING") {
					_.each(question.choices, (choice) => {
						defaultWeight[String(choice.id)] = 0;
					});
				}

				this.answers[question.id] = {
					text: "",
					comment: "",
					selected: defaultSelected,
					weight: defaultWeight,
					isSolved: false,
				};
			});
		},
		goBackToSurvey() {
			this.$confirm({
				title: this.$t("716"), //설문 응답을 종료하시겠습니까?
				content: this.$t("717"), //설문 응답 종료 시 현재까지 응답한 내용은 제출되지 않습니다.
				accept: this.$t("719"), //확인
				cancel: this.$t("718"), //취소
			})
				.then(() => {
					if (this.$route.query.distributionType === "SATISFACTION") {
						this.$router.push(
							this.routePath +
							this.$route.query.learnId +
							"?status=" +
							this.$route.query.status +
							"&tab=viewSurvey"
						);
					} else {
						this.$router.push({
							name: "IndependentSurveyTotalView",
							params: { distId: this.$route.params.distId },
							query: this.$route.query,
						});
					}
				})
				.catch(() => { });
		},
	},
};
</script>
<style scoped>
.w-120 {
	width: 130px;
}
</style>